import React, { Component } from 'react';
import GoogleMapReact from 'google-map-react';
import classNames from 'classnames';
import { GOOGLE_MAPS_API_KEY, REACT_APP_API_BASE, getPurchasingPowerTitle, getOriginTitle, getHouseholdTitle } from '../../config';
import { Select } from '../forms';
import { BarChart } from '../chart';
import Marker from '../map/marker';
import withAuthProvider from '../../hoc/withAuthProvider';
import SpinnerDots from '../spinner/dots';
import './unit.scss';
const images = require.context('../../images/logotypes', true);

const Population = ({ scbReportData, className }) => {
    return (
        <div className={className}>
            <h3 className="unit-scb__stats-heading">Befolkning</h3>
            <p className="unit-scb__stats-value">Antal invånare: {scbReportData.populationByAgeDataset.total.toLocaleString('sv')} st</p>
            <BarChart 
                data={scbReportData.populationByAgeDataset.dataItems.map(item => {
                    return {
                        name: item.title,
                        data: item.value
                    }})} 
                dataKeys={[
                    {
                        key: 'set1', 
                        background: '#c34353'
                    },
                    {
                        key: 'set2', 
                        background: '#f2b146'
                    },
                    {
                        key: 'set3', 
                        background: '#83b69c'
                    },
                    {
                        key: 'set4', 
                        background: '#0b3358'
                    },
                    {
                        key: 'set5', 
                        background: '#726454'
                    },
                    {
                        key: 'set6', 
                        background: '#79bafa'
                    },
                    {
                        key: 'set7', 
                        background: '#222'
                    }
                ]}/>
        </div>
    );
};

const PurchasingPower = ({ scbReportData, className }) => {
    return (
        <div className={className}>
            <h3 className="unit-scb__stats-heading">Köpkraft</h3>
            <p className="unit-scb__stats-value">Antal hushåll: {scbReportData.populationByEconomicStandardDataset.total.toLocaleString('sv')} st</p>
            <BarChart 
                data={scbReportData.populationByEconomicStandardDataset.dataItems.map(item => {
                    return {
                        name: getPurchasingPowerTitle(item.title),
                        data: item.value
                    }
                })} dataKeys={[
                    {
                        key: 'set1', 
                        background: '#c34353'
                    },
                    {
                        key: 'set2', 
                        background: '#f2b146'
                    },
                    {
                        key: 'set3', 
                        background: '#83b69c'
                    },
                    {
                        key: 'set4', 
                        background: '#0b3358'
                    },
                    {
                        key: 'set5', 
                        background: '#726454'
                    },
                    {
                        key: 'set6', 
                        background: '#79bafa'
                    },
                    {
                        key: 'set7', 
                        background: '#222'
                    }
                ]}/>
        </div>
    );
}

const Origin = ({ scbReportData, className }) => {
    return (
        <div className={className}>
            <h3 className="unit-scb__stats-heading">Ursprung</h3>
            <p className="unit-scb__stats-value">Antal personer: {scbReportData.populationByOriginDataset.total.toLocaleString('sv')} st</p>
            <BarChart 
                data={scbReportData.populationByOriginDataset.dataItems.map(item => {
                    return {
                        name: getOriginTitle(item.title),
                        data: item.value
                    }
                })} dataKeys={[
                    {
                        key: 'set1', 
                        background: '#c34353'
                    },
                    {
                        key: 'set2', 
                        background: '#f2b146'
                    },
                    {
                        key: 'set3', 
                        background: '#83b69c'
                    },
                    {
                        key: 'set4', 
                        background: '#0b3358'
                    },
                    {
                        key: 'set5', 
                        background: '#726454'
                    },
                    {
                        key: 'set6', 
                        background: '#79bafa'
                    },
                    {
                        key: 'set7', 
                        background: '#222'
                    }
                ]} />
        </div>
    );
}

const Household = ({ scbReportData, className }) => {
    return (
        <div className={className}>
            <h3 className="unit-scb__stats-heading">Hushåll</h3>
            <p className="unit-scb__stats-value">Antal hushåll: {scbReportData.houseHoldTypesDataset.total.toLocaleString('sv')} st</p>
            <BarChart 
                data={scbReportData.houseHoldTypesDataset.dataItems.map(item => {
                    return {
                        name: getHouseholdTitle(item.title),
                        data: item.value
                    }
                })} dataKeys={[
                    {
                        key: 'set1', 
                        background: '#c34353'
                    },
                    {
                        key: 'set2', 
                        background: '#f2b146'
                    },
                    {
                        key: 'set3', 
                        background: '#83b69c'
                    },
                    {
                        key: 'set4', 
                        background: '#0b3358'
                    },
                    {
                        key: 'set5', 
                        background: '#726454'
                    },
                    {
                        key: 'set6', 
                        background: '#79bafa'
                    },
                    {
                        key: 'set7', 
                        background: '#222'
                    }
                ]} />
        </div>
    );
};
class UnitSCBStats extends Component {
 
    state = {
        scbReportData: null,
        selectedValue: null,
        isLoading: true,
        isFetching: false
    }

    async componentDidUpdate(prevProps) {
        if (this.state.scbReportData) return;

        const layer = this.props.selections[0];
        const prevlayer = prevProps.selections[0];

        if (!layer.value) return;

        if (layer.value === prevlayer.value) return;

        const stats = await this.fetchScbStats(layer);

        this.setState({
            selectedValue: layer.value,
            scbReportData: stats.scbReportData,
            isLoading: false
        });
    }

    async fetchScbStats(layer) {
        //this.setState()
        const token = await this.props.getAccessToken();
        const headers = new Headers();
        const bearer = `Bearer ${token}`;
        headers.append('Authorization', bearer);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');

        const selectionLayer = {
            aregion: [],
            county: [],
            locality: [],
            municipality: [],
            parish: [],
            postalCodes: []
        };
        
        selectionLayer[layer.param].push(layer.value);
        
        const path = `${REACT_APP_API_BASE}/salesdistrict/scbdata`;
        try {
            const rawResponse = await fetch(path, {
                method: 'POST',
                headers: headers,
                body: JSON.stringify({
                    ...selectionLayer
                })
            });
        
            if (rawResponse.ok) {
                return  await rawResponse.json();
            }
        } catch(e) {
            return {
                scbReportData: null
            };
        }
    }

    getSelectedLayer(value) {
        return this.props.selections.filter(selection => selection.value === value)[0];
    }
    
    async handleChange(e) {
        const selectedValue = e.currentTarget.value;
        this.setState({
            selectedValue,
            isLoading: true
        });

        const layer = this.getSelectedLayer(selectedValue);
        const stats = await this.fetchScbStats(layer);
        this.setState({
            scbReportData: stats.scbReportData,
            isLoading: false
        });
    }

    getLogo() {

        const { unitData } = this.props;
        let src = null;
        try {
            src = images(`./${unitData.ChainCode}.png`);
        } catch {
            src = null;
        }
        return src;
    }


    render() {

        const { unitData } = this.props;

        if (!unitData) return null;

        const center = {
            lat: unitData.Latitude*1,
            lng: unitData.Longitude*1
        };

        const { scbReportData } = this.state;
       
        return (
            <>
                <section className={classNames({
                    'unit-scb': true,
                    'unit-scb--is-loading': this.state.isLoading
                })}>
                    <div className="unit-scb__map">
                        <div style={{width: "100%", height: '100vh',  maxHeight: "513px", minHeight: "513px"}}>
                            <GoogleMapReact
                                bootstrapURLKeys={{
                                    key: GOOGLE_MAPS_API_KEY,                                            
                                    language: 'sv' 
                                }}
                                defaultCenter={center}
                                defaultZoom={13}
                            >
                                <Marker
                                    marker={{
                                        logo: this.getLogo()
                                    }}
                                    lat={center.lat}
                                    lng={center.lng}
                                    text="My Marker"
                                />
                            </GoogleMapReact>
                        </div>
                    </div>
                    <div className="unit-scb__content">
                        <header className="unit-scb__header">
                            <div className="unit-scb__header-content">
                                <h2 className="unit-scb__heading">Statistik från SCB</h2>
                                <Select modifiers={{
                                    'unit-scb__filter': true
                                }} name="filter" onChange={(e) => this.handleChange(e)} value={this.state.selectedValue ? this.state.selectedValue : ''}>
                                    {this.props.selections.map(selection => {
                                        return (
                                            <option key={selection.id} value={selection.value}>{selection.name}</option>
                                        )
                                    })}
                                </Select>
                            </div>
                        </header>
                        {scbReportData &&
                            <>
                                <div className="unit-scb__stats">
                                    <div className="unit-scb__stats-content unit-scb__stats-content--no-bottom-padding">
                                        <Population scbReportData={scbReportData} className="unit-scb__stats-col" />
                                        <PurchasingPower scbReportData={scbReportData} className="unit-scb__stats-col" />
                                    </div>
                                </div>
                                <div className="unit-scb__stats">
                                    <div className="unit-scb__stats-content unit-scb__stats-content--last">
                                        <Origin scbReportData={scbReportData} className="unit-scb__stats-col" />
                                        <Household scbReportData={scbReportData} className="unit-scb__stats-col" />
                                    </div>
                                </div>

                                
                            </>
                        }
                        <SpinnerDots />
                    </div>
                </section>
                {scbReportData &&
                    <div className="unit-scb__print-stats">
                        <Population scbReportData={scbReportData} className="unit-scb__stats-col-print" />
                        <PurchasingPower scbReportData={scbReportData} className="unit-scb__stats-col-print" />
                        <Origin scbReportData={scbReportData} className="unit-scb__stats-col-print" />
                        <Household scbReportData={scbReportData} className="unit-scb__stats-col-print" />
                    </div>
                }
            </>
            
        );
    }

};

export default withAuthProvider(UnitSCBStats);